import { Stack, Typography } from '@mui/material'

import { HoleByHoleColumnHeaderItem, HoleByHoleRowHeaderItem, TotalScores } from './styles'

const generateHeaderCells = (start: number, end: number) => {
  return Array.from({ length: end - start }, (_, i) => (
    <HoleByHoleColumnHeaderItem key={i}>
      <Typography variant="body2">{start + i}</Typography>
    </HoleByHoleColumnHeaderItem>
  ))
}

export const GolfHoleByHoleHeader = () => {
  return (
    <Stack direction="row">
      <HoleByHoleRowHeaderItem>
        <Typography variant="body2">Hole</Typography>
      </HoleByHoleRowHeaderItem>
      {generateHeaderCells(1, 10)}
      <HoleByHoleColumnHeaderItem highlight>
        <Typography variant="body2">OUT</Typography>
      </HoleByHoleColumnHeaderItem>
      {generateHeaderCells(10, 19)}
      <HoleByHoleColumnHeaderItem highlight>
        <Typography variant="body2">IN</Typography>
      </HoleByHoleColumnHeaderItem>
      <TotalScores>
        <HoleByHoleColumnHeaderItem>
          <Typography variant="body2" fontWeight="bold">
            Par
          </Typography>
        </HoleByHoleColumnHeaderItem>
        <HoleByHoleColumnHeaderItem>
          <Typography variant="body2" fontWeight="bold">
            Total
          </Typography>
        </HoleByHoleColumnHeaderItem>
      </TotalScores>
    </Stack>
  )
}
